// extracted by mini-css-extract-plugin
module.exports = {"productsGrid":"_1RkJr","isMobile":"_1hWOc"};